import React from 'react';
import {
  Checkbox,
  Button,
  OverlayTrigger,
  Popover,
  Glyphicon,
} from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class MarketTypeFilter extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    items: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      actives: this.props.actives,
    };
  }

  onChange(value, ev) {
    const target = ev.target; // for event pooling
    this.setState(
      (state) => {
        const { actives } = state;
        if (target.checked) {
          actives.length = 0;
          actives.push(value);
        } else {
          const idx = actives.indexOf(value);
          actives.splice(idx, 1);
        }
        return actives;
      },
      () => this.props.onChange(this.state.actives),
    );
  }

  renderPopup() {
    return (
      <Popover id="shipment-types-popup">
        <ul className="filter-dropdown-wrapper">
          {this.props.items.map((market) => (
            <li key={market}>
              <Checkbox
                checked={this.props.actives.indexOf(market) > -1}
                onChange={(e) => this.onChange(market, e)}
              >
                {humanize(market)}
              </Checkbox>
            </li>
          ))}
        </ul>
      </Popover>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className={this.props.className}>
        <OverlayTrigger
          className={this.props.className}
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderPopup()}
        >
          <div>
            <Button
              bsStyle="default"
              style={{ outline: 'none' }}
              bsSize="small"
            >
              {titleize(t('MARKET', { count: 2 }))}
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

MarketTypeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array,
  actives: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
};

export default withTranslation()(MarketTypeFilter);
